import React, { useEffect, useState } from 'react';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import {
    Grid,
    Paper,
    Box,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Backdrop,
    CircularProgress,
    Switch,
    FormControlLabel,
    Divider,
} from '@material-ui/core';
import { useParams } from 'react-router';
import PieAndTable from './PieAndTable';
import BarAndTable from './BarAndTable';
import MaterialTable from '@material-table/core';
import { tableIcons } from '../../../@jumbo/constants/TableConstants';
import { useSelector } from 'react-redux';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import 'date-fns';
import { startOfMonth, endOfMonth, format } from 'date-fns';
import localeptBR from 'date-fns/locale/pt-BR';
import DateFnsUtils from '@date-io/date-fns';
import axios_instance from '../../../services/auth/jwt/config';
import VencidaBarAndTable from './VencidaBarAndTable';
import { Alert } from '@material-ui/lab';
import { useMainContext } from '../../../redux/MainContext';
import configurationService from '../../../services/f5-services/configurationService';

const _titles = {
    geral: 'Geral',
    entradas: 'por Entradas',
    classificacao: 'por Classificação',
    regiao: 'por Região',
    tipo: 'por Tipo',
    pendentes: 'Pendentes',
    vencidas: 'Vencidas',
    departamento: 'por Departamento',
};

const _link = {
    geral: '/relatorio/mensalglobal',
    entradas: '/relatorio/mensalglobal',
    classificacao: '/relatorio/mensalglobal',
    regiao: '/relatorio/mensalglobal',
    tipo: '/relatorio/mensalglobal',
    pendentes: '/relatorio/pendentes',
    vencidas: '/relatorio/vencidasfull',
    departamento: '/relatorio/departamento',
};

const _mode = {
    geral: '',
    entradas: '&mode=entradas',
    classificacao: '&mode=classificacao',
    regiao: '&mode=regiao',
    tipo: '&mode=tipo',
    pendentes: '',
    vencidas: '',
    departamento: '',
};

const _has = {
    geral: { month: true, year: true, departamento: false, external: true, encerrada: false, graphOnly: true },
    entradas: { month: true, year: true, departamento: false, external: false, encerrada: false, graphOnly: false },
    classificacao: { month: true, year: true, departamento: false, external: false, encerrada: false, graphOnly: false },
    regiao: { month: true, year: true, departamento: false, external: false, encerrada: false, graphOnly: false },
    tipo: { month: true, year: true, departamento: false, external: false, encerrada: false, graphOnly: false },
    pendentes: { month: false, year: false, departamento: false, external: false, encerrada: false, graphOnly: false },
    vencidas: { month: true, year: true, departamento: true, external: true, encerrada: true, graphOnly: false },
    departamento: { month: true, year: true, departamento: true, external: true, encerrada: false, graphOnly: false, categoria: true },
};

const Report = () => {
    const [start, setStart] = useState(startOfMonth(new Date()));
    const [end, setEnd] = useState(endOfMonth(new Date()));
    const [departamento, setDepartamento] = useState(null);
    const [encerrada, setEncerrada] = useState(null);
    const [categoriaId, setCategoriaId] = useState(null);
    const [categorias, setCategorias] = useState([]);
    const [graphOnly, setGraphOnly] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const { dashboard } = useMainContext();
    const departmentList = dashboard?.departamentos || [];
    const { mode } = useParams();

    useEffect(() => {
        setData(null);
    }, [mode]);

    useEffect(() => {
        if (!_has[mode]?.categoria) return;
        configurationService
            .getConfigParameter('categoria')
            .then(r => setCategorias(r.items || []))
            .catch(() => setCategorias([]));
    }, [mode]);

    const openRelatorio = () => {
        if (mode === 'departamento' && !departamento) return;
        setLoading(true);
        let link = `https://capeladoalto.cidadeinteligente.app.br/api/ouvidoria/web${_link[mode]}${mode === 'departamento' ? `/${departamento}` : ''}`;
        axios_instance
            .get(
                `${link}`,
                {
                    params:{
                        start: format(start, 'yyyy-MM-dd'),
                        end: format(end, 'yyyy-MM-dd'),
                        mode: _mode[mode],
                        departamento: departamento,
                        graphOnly: graphOnly,
                        json: true,
                        encerrada: encerrada,
                        categoria_id: _has[mode].categoria ? categoriaId : undefined,
                    }
                }
            )
            .then(r => {
                setData(r.data);
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
            });
    };

    const openPrintRelatorio = () => {
        let link = `https://capeladoalto.cidadeinteligente.app.br/ouvidoria${_link[mode]}`;
        window.open(
            `${link}?start=${format(start, 'yyyy-MM-dd')}&end=${format(end, 'yyyy-MM-dd')}${_mode[mode]}${departamento ? `&departamento=${departamento}` : ''
            }${graphOnly ? '&graphOnly=true' : ''}`,
            '_blank',
        );
    };

    const openGeralRelatorio = () => {
        if (mode === 'departamento') {
            if (!departamento) return;
            setLoading(true);
            axios_instance
                .get(
                    `https://capeladoalto.cidadeinteligente.app.br/api/ouvidoria/web${_link[mode]}/${departamento}`,
                    {
                        params: {
                            start: format(start, 'yyyy-MM-dd'),
                            end: format(end, 'yyyy-MM-dd'),
                            categoria_id: categoriaId,
                        },
                        responseType: 'blob',
                    },
                )
                .then(r => {
                    // type html
                    const url = window.URL.createObjectURL(new Blob([r.data], { type: 'text/html;charset=utf-8' }));
                    const a = document.createElement('a');
                    a.href = url;
                    a.target = '_blank';
                    a.click();
                    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
                    setLoading(false);
                })
                .catch(() => setLoading(false));
            return;
        }
        setLoading(true);
        let link = `https://capeladoalto.cidadeinteligente.app.br/api/ouvidoria/web${_link[mode]}`;
        let token = localStorage.getItem('token');
        fetch(
            `${link}?start=${format(start, 'yyyy-MM-dd')}&end=${format(end, 'yyyy-MM-dd')}${_mode[mode]}${departamento ? `&departamento=${departamento}` : ''
            }${graphOnly ? '&graphOnly=true' : ''}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            },
        )
            .then(r => r.blob())
            .then(blob => {
                let url = window.URL.createObjectURL(new Blob([blob], { type: 'text/html;charset=utf-8' }));
                let a = document.createElement('a');
                a.href = url;
                a.target = '_blank';
                a.click();
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
            });
    };

    return <PageContainer>
        <Backdrop open={loading} style={{ zIndex: 9999 }}>
            <CircularProgress color="inherit" />
        </Backdrop>
        <Paper style={{ marginBottom: 16 }}>
            <Box p={2}>
                <h2>Relatório {_titles[mode]}</h2>
                <Box mt={2}>
                    <MuiPickersUtilsProvider locale={localeptBR} utils={DateFnsUtils}>
                        <Grid container spacing={1} alignItems="center" justifyContent="center">
                            {_has[mode].month ? (
                                <Grid item xs={3}>
                                    <Box width="100%" ml={4}>
                                        <KeyboardDatePicker
                                            fullWidth
                                            format="dd/MM/yyyy"
                                            value={start}
                                            onChange={date => setStart(date)}
                                            label="Data Inicial"
                                            inputVariant="outlined"
                                        />
                                    </Box>
                                </Grid>
                            ) : null}
                            {_has[mode].year ? (
                                <Grid item xs={3}>
                                    <Box width="100%" ml={4}>
                                        <KeyboardDatePicker
                                            fullWidth
                                            format="dd/MM/yyyy"
                                            value={end}
                                            onChange={date => setEnd(date)}
                                            label="Data Final"
                                            inputVariant="outlined"
                                        />
                                    </Box>
                                </Grid>
                            ) : null}
                            {_has[mode].departamento ? (
                                <Grid item xs={3}>
                                    <Box width="100%" ml={4}>
                                        <FormControl fullWidth variant="outlined">
                                            <InputLabel>Departamento</InputLabel>
                                            <Select
                                                label="Departamento"
                                                value={departamento}
                                                onChange={event => setDepartamento(event.target.value)}
                                            >
                                                {mode !== 'departamento' ? <MenuItem value={null}>Todos os Departamentos</MenuItem> : null}
                                                {departmentList.map((dep, index) => (
                                                    <MenuItem key={index} value={dep.id}>
                                                        {dep.nome}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>
                            ) : null}
                            {_has[mode].categoria ? (
                                <Grid item xs={3}>
                                    <Box width="100%" ml={4}>
                                        <FormControl fullWidth variant="outlined">
                                            <InputLabel>Categoria</InputLabel>
                                            <Select
                                                label="Categoria"
                                                value={categoriaId}
                                                onChange={event => setCategoriaId(event.target.value)}
                                            >
                                                <MenuItem value={null}>Todas as Categorias</MenuItem>
                                                {categorias.map(cat => (
                                                    <MenuItem key={cat.id} value={cat.id}>
                                                        {cat.nome}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>
                            ) : null}
                            {_has[mode].encerrada ? (
                                <Grid item xs={3}>
                                    <Box width="100%" ml={4}>
                                        <FormControl fullWidth variant="outlined">
                                            <InputLabel>Status</InputLabel>
                                            <Select
                                                label="Status"
                                                value={encerrada}
                                                onChange={event => setEncerrada(event.target.value)}
                                            >
                                                <MenuItem value={null}>Todos</MenuItem>
                                                <MenuItem value={'sim'}>Encerradas</MenuItem>
                                                <MenuItem value={'nao'}>Não Encerradas</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>
                            ) : null}
                            <Grid item xs={3}>
                                <Box width="100%" ml={4} >
                                    <Button variant="contained" color="primary" onClick={openRelatorio}>
                                        Visualizar
                                    </Button>
                                    {_has[mode].external ? (
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => openGeralRelatorio()}
                                        >
                                            Exportar
                                        </Button>
                                    ) : (
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={openPrintRelatorio}
                                        >
                                            Versão para Imprimir
                                        </Button>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </MuiPickersUtilsProvider>
                </Box>
            </Box>
            <Box p={2} alignItems="center" justifyContent="center" width="100%">
                {_has[mode].graphOnly ? <FormControlLabel
                    control={
                        <Switch
                            checked={graphOnly}
                            onChange={() => setGraphOnly(!graphOnly)}
                            color="primary"
                        />
                    }
                    label="Apenas Gráficos"
                /> : null}
            </Box>
        </Paper>
        {data ? (
            <>
                {mode === 'geral' ? (
                    <Paper>
                        <Box p={2}>
                            <h2>
                                Relatório {_titles[mode]} de {format(start, 'dd/MM/yyyy')} até{' '}
                                {format(end, 'dd/MM/yyyy')}
                            </h2>
                            <PieAndTable
                                data={data.entradas}
                                title="1. Ocorrências por Meio (Entrada)"
                                name="Entrada"
                            />
                            <PieAndTable
                                data={data.gravidade}
                                title="2. Ocorrências por Gravidade"
                                name="Gravidade"
                            />
                            <BarAndTable
                                data={data.departamento}
                                title="3. Ocorrências por Departamentos"
                                name="Departamento"
                            />
                            <BarAndTable data={data.servicos} title="4. Ocorrências por Serviços" name="Serviço" />
                        </Box>
                    </Paper>
                ) : mode === 'departamento' ? (
                    <Paper>
                        <Box p={2}>
                            <h2>
                                Relatório {_titles[mode]} de {format(start, 'dd/MM/yyyy')} até{' '}
                                {format(end, 'dd/MM/yyyy')}
                            </h2>
                            <PieAndTable
                                data={data.entradas}
                                title="1. Ocorrências por Meio (Entrada)"
                                name="Entrada"
                            />
                            <PieAndTable
                                data={data.gravidade}
                                title="2. Ocorrências por Gravidade"
                                name="Gravidade"
                            />
                            <BarAndTable data={data.servicos} title="3. Ocorrências por Serviços" name="Serviço" />
                            <Box mt={2}>
                                <MaterialTable
                                    data={data.ocorrencias || []}
                                    icons={tableIcons}
                                    title="4. Ocorrências"
                                    columns={[
                                        { title: 'Protocolo', field: 'protocolo' },
                                        { title: 'Solicitante', field: 'solicitante' },
                                        { title: 'Serviço', field: 'servico' },
                                        {
                                            title: 'Abertura',
                                            field: 'abertura',
                                            render: row => (row.abertura ? new Date(row.abertura).toLocaleDateString() : '---'),
                                        },
                                        {
                                            title: 'Prazo',
                                            field: 'prazo',
                                            render: row => (row.prazo ? new Date(row.prazo).toLocaleDateString() : '---'),
                                        },
                                    ]}
                                />
                            </Box>
                        </Box>
                    </Paper>
                ) : mode === 'vencidas' ? (
                    <Paper>
                        <Box p={2}>
                            <h2>Relatório de ocorrências vencidas</h2>
                            {data.servicos.length === 0 ? <Alert severity="info">Nenhuma ocorrência vencida encontrada no período selecionado.</Alert> : null}
                            <BarAndTable
                                data={data.departamento}
                                title="1. Vencidas por Departamento"
                                name="Departamento"
                            />
                            <Divider />
                            <BarAndTable
                                data={data.servicos}
                                title="2. Vencidas por Serviço"
                                name="Departamento"
                            />
                            <Divider />
                            <VencidaBarAndTable
                                data={data.ocorrencias}
                                title="3. Vencidas por dias"
                                name="Departamento"
                            />
                            <Divider />
                            {encerrada === null ? <PieAndTable
                                data={data.status}
                                title="4. Vencidas por Status"
                                name="Status"
                            /> : null}
                        </Box>
                    </Paper>
                ) : mode === 'pendentes' ? (
                    data.ocorrencias.map(dep => (
                        <MaterialTable
                            data={dep?.ocorrencias}
                            icons={tableIcons}
                            title={`Departamento: ${dep.departamento}`}
                            columns={[
                                { title: 'Protocolo', field: 'protocolo' },
                                { title: 'Solicitante', field: 'solicitante' },
                                { title: 'Serviço', field: 'servico' },
                                {
                                    title: 'Abertura',
                                    field: 'abertura',
                                    render: data => new Date(data.abertura).toLocaleDateString(),
                                },
                                {
                                    title: 'Prazo',
                                    field: 'prazo',
                                    render: data => new Date(data.prazo).toLocaleDateString(),
                                },
                            ]}
                        />
                    ))
                ) : null}
            </>
        ) : null}
        {/* <Dialog open={modal} onClose={() => setModal(false)} fullWidth>
                <DialogTitle>
                    <Grid container justifyContent="space-between" alignItems="center">
                        <Grid item xs={3}>
                            <h4>Exportar Relatório</h4>
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton onClick={() => setModal(false)}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <Box width="100%" ml={4}>
                        <Typography>Insira aqui as considerações gerais da ouvidoria municipal</Typography>
                        <TextField
                            multiline
                            minRows={4}
                            fullWidth
                            variant="outlined"
                            label="Considerações gerais"
                            value={obs}
                            onChange={e => setObs(e.target.value)}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="primary" onClick={openGeralRelatorio}>
                        Exportar
                    </Button>
                </DialogActions>
            </Dialog> */}
    </PageContainer>
};

export default Report;
